// extracted by mini-css-extract-plugin
module.exports = {"box_container":"DashboardCardBoxes_box_container__2edr9"};